export default "__VITE_ASSET__DuEbmwRD__"